import React, {ReactElement} from "react";
import {useSelector} from "react-redux";
import {Redirect, Route, RouteProps} from "react-router-dom";
import {useAuthStore} from "../../features/auth/api/useAuthStore";
import {parseReturnUrl} from "../../utils/returnUrl";

interface Props {
  children?: ReactElement<any>;
}

const PrivateRoute: React.FC<Props & RouteProps> = (props: Props) => {
  const {children, ...rest} = props;
  const {data: {isAuth}} = useAuthStore();

  const returnUrl = parseReturnUrl();
  const query = !returnUrl ? "" : `?ReturnUrl=${encodeURIComponent(returnUrl)}`;

  return (
    <Route {...rest}>
      {isAuth ? children : <Redirect to={`/login${query}`} />}
    </Route>
  );
};

export default PrivateRoute;
